import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/root/zhubao-pc/layouts/default.vue").then(m => m.default || m))
}